module.exports = __webpack_public_path__ + "img/montenegro.05b1ac9.webp";